import { Popover } from 'antd';
import styles from './index.module.scss';
import { cls } from 'reactutils';
const PopoverContent = ({ type = 1, horzontalOffset = 50, tradeMode = 1 }) => {
  return (
    <div className="pay-question-content">
      {type === 1 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单时选择结算付款，
            {tradeMode === 2 ? (
              <span>供应商按订单履约。双方基于订单进行结算、付款。</span>
            ) : (
              <span>
                供应商接收到订单，即可安排发货。在采购企业确认收货后，双方基于{' '}
                <span className="pay-question-desc-light-txt">收货单</span> 进行结算、付款。
              </span>
            )}
          </p>
          <div className="pay-question-content-title">交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-content-box pay-question-content-box-big">
              <div className="pay-question-content-box-txt">结算对账</div>
            </div>
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                {tradeMode === 2 ? (
                  <div className="pay-question-content-box-txt">供应商履约</div>
                ) : (
                  <div className="pay-question-content-box-txt">
                    供应商依据
                    <br />
                    订单发货
                  </div>
                )}
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                {tradeMode === 2 ? (
                  <div className="pay-question-content-box-txt">
                    采购商
                    <br />
                    完成订单
                  </div>
                ) : (
                  <div className="pay-question-content-box-txt">
                    采购商
                    <br />
                    收货/验货
                  </div>
                )}
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
            </div>
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商按约定
                  <br />
                  进行付款
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">供应商开具发票</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">发起支付</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 2 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单时选择货到付款。供应商接收到订单，即可安排发货。采购企业收货验收，在订单完成后按{' '}
            <span className="pay-question-desc-light-txt">收货金额</span>{' '}
            结清货款。此种交易方式无结算对账流程。
          </p>
          <div className="pay-question-content-title">货到付款交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商依据
                  <br />
                  订单发货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商
                  <br />
                  收货/验货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商付款</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 3 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单选择先款后货，提交订单后直接支付全额货款给供应商。供应商将在收到货款后安排发货，采购商收货，完成交易。
          </p>
          <div className="pay-question-content-title">交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商付款</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商收到货款
                  <br />
                  后，安排发货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商
                  <br />
                  收货/验货
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 4 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单时选择账期交易，供应商接收到订单，即可安排发货。采购企业在确认收货后按约定的日期、方式进行结算和付款。
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            请依据合同内容选择交易方式，约定为按月结算、按量结算或固定日付款等，都适用账期交易；
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            采购企业需选择非合同约定的交易方式时，请确认与供应商已提前协商。否则供应商可拒绝订单；
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            系统提供采购企业编制结算单 ，供应商确认对账等相关结算、支付流程功能
          </p>
          <div className="pay-question-content-title">账期交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-content-box pay-question-content-box-big">
              <div className="pay-question-content-box-txt">
                采购商
                <br />
                编制结算单
              </div>
            </div>
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商依据
                  <br />
                  订单发货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商进行
                  <br />
                  收货/验货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
            </div>
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商按约定
                  <br />
                  进行付款
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">供应商开具发票</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商对结算单
                  <br />
                  进行对账确认
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-left" />
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 5 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单时选择货到付款。供应商接收到订单，即可安排发货。采购企业在验收后交付货款。
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            请依据合同内容选择交易方式；
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            采购企业需选择非合同约定的交易方式时，请确认与供应商已提前协商。否则供应商可拒绝订单；
          </p>
          <div className="pay-question-content-title">货到付款交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商依据
                  <br />
                  订单发货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商进行
                  <br />
                  收货/验货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商付款</div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 6 && (
        <div>
          <p className="pay-question-desc">
            采购企业下单后，通过银行转账等方式支付货款给供应商。供应商将在收到货款后安排发货。
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            请依据合同内容选择交易方式；
          </p>
          <p className="pay-question-desc pay-question-desc-has-dot">
            采购企业需选择非合同约定的交易方式时，请确认与供应商已提前协商。否则供应商可拒绝订单；
          </p>
          <div className="pay-question-content-title">交易流程</div>
          <div className="pay-question-progress">
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商付款</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  供应商收到货款
                  <br />
                  后，安排发货
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">
                  采购商进行
                  <br />
                  收货/验货
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {type === 7 && (
        <div className="type-7">
          <p className="pay-question-desc">
            采购企业下单选择预付款，提交订单后按约定预付货款，供应商收到预付货款后安排发货。采购商收货，交易完成后按
            <span className="price-desc">收货金额</span>
            结清剩余货款。
          </p>
          <div className="pay-question-content-title">交易流程</div>

          <div className="pay-question-progress">
            <div className="pay-question-progress-line">
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商下单</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">采购商预付款</div>
              </div>
              <div className="pay-question-content-arrow-wrap">
                <i className="iconfont icon-arrows-right" />
              </div>
              <div className="pay-question-content-box">
                <div className="pay-question-content-box-txt">供应商发货</div>
              </div>
              <div className="pay-question-content-box pay-question-content-box-bottom pay-question-content-box-long">
                <div className="pay-question-content-box-txt">
                  采购商
                  <br />
                  完成订单，支付全部
                </div>
              </div>
              <div className="pay-question-content-arrow-wrap pay-question-content-box-bottom">
                <i className="iconfont icon-arrows-left" />
              </div>
              <div className="pay-question-content-box pay-question-content-box-bottom">
                <div className="pay-question-content-box-txt">
                  采购商
                  <br />
                  收货/验货
                </div>
              </div>
              <div className="type-7-vertical-line-wrap">
                <div className="type-7-line" />
                <i className="iconfont icon-arrow-down type-7-arrow" />
                <span className="type-7-txt">支持多批次</span>
              </div>
            </div>
          </div>
        </div>
      )}
      <style jsx>{`
        :global(.ant-popover-inner-content) {
          // background-color: #fff;
          padding: 0px;
        }
        .pay-question-content {
          text-align: left;
          cursor: auto;
          padding: 20px 25px 25px 25px;
          width: 552px;
          background-color: #fff;
        }
        .pay-question-icon {
          color: #999999;
        }
        .vue-popover-icon-wrap:hover .pay-question-icon {
          color: var(--rv-primary-color);
        }
        .pay-question-content .pay-question-desc {
          font-size: 12px;
          color: #333333;
          line-height: 24px;
          position: relative;
          letter-spacing: -0.7px;
        }
        .pay-question-content .pay-question-desc.pay-question-desc-has-dot {
          padding-left: 10px;
        }
        .pay-question-content .pay-question-desc.pay-question-desc-has-dot:before {
          content: "";
          width: 4px;
          height: 4px;
          background-color: var(--rv-primary-color);
          position: absolute;
          left: 0;
          top: 10px;
          border-radius: 50%;
        }
        .pay-question-content .pay-question-content-title {
          font-size: 12px;
          color: #333333;
          font-weight: bold;
          line-height: 1;
          margin-top: 16px;
          margin-bottom: 15px;
        }
        .pay-question-content .pay-question-progress {
          position: relative;
          font-size: 0;
        }
        .pay-question-content .pay-question-progress .pay-question-progress-line {
          margin-bottom: 12px;
          font-size: 0;
        }
        .pay-question-content
          .pay-question-progress
          .pay-question-progress-line:last-child {
          margin-bottom: 0;
        }
        .pay-question-content .pay-question-content-box {
          width: 100px;
          height: 50px;
          background: #e7f4fb;
          border: 1px solid #77cffc;
          border-radius: 2px;
          position: relative;
          display: inline-block;
          vertical-align: middle;
        }
        .pay-question-content
          .pay-question-content-box
          .pay-question-content-box-txt {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          -ms-transform: translate(-50%, -50%);
          -moz-transform: translate(-50%, -50%);
          -webkit-transform: translate(-50%, -50%);
          width: 100px;
          font-size: 12px;
          color: #333333;
          text-align: center;
          letter-spacing: 0;
          line-height: 16px;
        }
        .pay-question-content .pay-question-content-arrow-wrap {
          width: 33px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          display: inline-block;
          vertical-align: middle;
          font-size: 24px;
          color: #77cffc;
        }
        .pay-question-content .pay-question-content-box.pay-question-content-box-big {
          position: absolute;
          right: 0;
          top: 0;
          height: 112px;
        }
      
        .pay-question-content .type-7 .pay-question-content-box {
          width: 136px;
        }
      
        .pay-question-content .type-7 .pay-question-content-box-long {
          width: 319px;
        }
      
        .pay-question-content .type-7 .pay-question-content-box-bottom {
          margin-top: 37px;
        }
      
        .pay-question-content .type-7 .pay-question-content-arrow-wrap {
          width: 45px;
        }
      
        .pay-question-content .type-7 .type-7-vertical-line-wrap {
          position: absolute;
          right: 68px;
          top: 50px;
        }
      
        .pay-question-content .type-7 .type-7-line {
          width: 1px;
          height: 34px;
          background-color: var(--rv-primary-color);
          position: absolute;
        }
      
        .pay-question-content .type-7 .type-7-arrow {
          position: absolute;
          color: var(--rv-primary-color);
          top: 25px;
          left: -6px;
        }
      
        .pay-question-content .type-7 .type-7-txt {
          color: #333333;
          font-size: 12px;
          line-height: 18px;
          position: absolute;
          left: -30px;
          width: 64px;
          background-color: #fff;
          top: 7px;
        }
      
        .pay-question-content
          .type-7
          .pay-question-content-box
          .pay-question-content-box-txt {
          width: 100%;
        }
      
        .pay-question-desc .price-desc {
          color: rgba(255, 51, 0, 0.647058823529412);
        }
      
        .pay-question-desc .pay-question-desc-light-txt {
          color: rgba(255, 51, 0, 0.447058823529412);
        }
        `}</style>
    </div>
  );
};
const PayQuestionIcon = (props) => {
  return (
    <Popover content={<PopoverContent {...props} />} trigger="hover">
      <i className={cls('iconfont icon-question1', styles.pay_question_icon)} />
    </Popover>
  );
};

export default PayQuestionIcon;
